import { LOGO_EMBLEM } from "@/data/albums";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#050505] px-6 md:px-12 pt-20 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <h3 className="font-serif text-5xl md:text-6xl tracking-tight leading-[0.9] text-[#f2f0ec]">
            Nothing here was<br />made to be background.
          </h3>
          <p className="mt-6 font-mono text-xs text-[#8a8a8a] max-w-sm leading-relaxed">
            ØČËĀŃ. Composer and producer. Worlds built out of sound, filed under one name.
          </p>
        </div>
        <div className="md:col-span-3 md:col-start-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a] mb-4">Elsewhere</p>
          <ul className="space-y-3 font-mono text-sm">
            <li><a href="https://untitled.stream" target="_blank" rel="noreferrer" className="link-underline text-[#f2f0ec]" data-testid="footer-untitled">untitled.stream</a></li>
            <li><a href="mailto:contact@ocean-music.com" className="link-underline text-[#f2f0ec]" data-testid="footer-email">contact@ocean-music.com</a></li>
          </ul>
        </div>
        <div className="md:col-span-2 flex md:justify-end items-start">
          <img src={LOGO_EMBLEM} alt="ØČËĀŃ emblem" className="w-20 h-20 object-contain opacity-70" style={{ filter: "invert(1) brightness(1.15) contrast(2.6)", mixBlendMode: "screen" }} />
        </div>
      </div>
      <div className="mt-16 flex flex-col md:flex-row justify-between gap-4 border-t border-white/5 pt-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#555]">© {year} ØČËĀŃ. All rights reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#555]">Made in private. Filed here.</p>
      </div>
    </footer>
  );
};
